import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Home", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Configuration", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-tabs" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      "data-bs-toggle": "tab",
      "data-bs-target": "#districts-tab",
      type: "button",
      role: "tab"
    }, "Districts")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#building-types-tab",
      type: "button",
      role: "tab"
    }, "Building Types")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#building-interior-types-tab",
      type: "button",
      role: "tab"
    }, "Building Interior Types")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#floor-types-tab",
      type: "button",
      role: "tab"
    }, "Floor Types")
  ])
], -1)
const _hoisted_7 = { class: "tab-content mt-2" }
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "districts-tab"
}
const _hoisted_9 = {
  key: 0,
  class: "table responsive"
}
const _hoisted_10 = { class: "table table-striped table-hover" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Map"),
    /*#__PURE__*/_createElementVNode("th", null, "Anchor Points"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-image" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "text-end text-nowrap" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "tab-pane fade",
  id: "building-types-tab"
}
const _hoisted_23 = {
  key: 0,
  class: "table responsive"
}
const _hoisted_24 = { class: "table table-striped table-hover" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Image"),
    /*#__PURE__*/_createElementVNode("th", null, "Max Nb. of Floors"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-image" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "text-end text-nowrap" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  class: "tab-pane fade",
  id: "building-interior-types-tab"
}
const _hoisted_37 = {
  key: 0,
  class: "table responsive"
}
const _hoisted_38 = { class: "table table-striped table-hover" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Image"),
    /*#__PURE__*/_createElementVNode("th", null, "Anchor Points"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-image" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "text-end text-nowrap" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger" }, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  class: "tab-pane fade",
  id: "floor-types-tab"
}
const _hoisted_51 = {
  key: 0,
  class: "table responsive"
}
const _hoisted_52 = { class: "table table-striped table-hover" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Image"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_54 = ["href"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-image" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "text-end text-nowrap" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger" }, null, -1)
const _hoisted_63 = [
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_district_modal = _resolveComponent("district-modal")!
  const _component_building_type_modal = _resolveComponent("building-type-modal")!
  const _component_building_interior_type_modal = _resolveComponent("building-interior-type-modal")!
  const _component_floor_type_modal = _resolveComponent("floor-type-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.authStore.isAdmin())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_district_modal, {
                "btn-text": 'Add District',
                "btn-class": "btn btn-primary",
                onOnUpdate: _ctx.districtUpdated
              }, null, 8, ["onOnUpdate"]),
              (_ctx.districts.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("table", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districts, (district) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: district.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(district.name), 1),
                            _createElementVNode("td", null, [
                              (district.map)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: district.mapSigned,
                                    download: ""
                                  }, _hoisted_14, 8, _hoisted_12))
                                : (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17))
                            ]),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(district.anchorPoints, (point, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: index,
                                  class: "border border-2 me-1 px-1"
                                }, _toDisplayString(point), 1))
                              }), 128))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_district_modal, {
                                  "btn-text": '',
                                  "btn-class": 'text-decoration-none text-primary px-1',
                                  "btn-icon": 'bi bi-pencil',
                                  "modal-title": 'Edit District [' + district.name + ' (' + district.id + ')]',
                                  district: district,
                                  onOnUpdate: _ctx.districtUpdated
                                }, null, 8, ["modal-title", "district", "onOnUpdate"]),
                                _createElementVNode("a", {
                                  href: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.onDeleteDistrict(district)), ["prevent"]),
                                  class: "text-decoration-none pe-1"
                                }, _hoisted_21, 8, _hoisted_19)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_building_type_modal, {
                "btn-text": 'Add Building Type',
                "btn-class": "btn btn-primary",
                onOnUpdate: _ctx.buildingXTypesReset
              }, null, 8, ["onOnUpdate"]),
              (_ctx.buildingTypes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("table", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildingTypes, (buildingType) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: buildingType.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(buildingType.id), 1),
                            _createElementVNode("td", null, _toDisplayString(buildingType.name), 1),
                            _createElementVNode("td", null, [
                              (buildingType.image)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    target: "_blank",
                                    href: buildingType.imageSigned,
                                    download: ""
                                  }, _hoisted_28, 8, _hoisted_26))
                                : (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31))
                            ]),
                            _createElementVNode("td", null, _toDisplayString(buildingType.maxFloors), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_building_type_modal, {
                                  "btn-class": 'text-decoration-none text-primary px-1',
                                  "btn-text": '',
                                  "modal-title": 'Edit Building Type [' + buildingType.name + ' (' + buildingType.id + ')]',
                                  "btn-icon": 'bi bi-pencil',
                                  "building-type": buildingType,
                                  onOnUpdate: _ctx.buildingXTypesReset
                                }, null, 8, ["modal-title", "building-type", "onOnUpdate"]),
                                _createElementVNode("a", {
                                  href: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.onDeleteBuildingType(buildingType)), ["prevent"]),
                                  class: "text-decoration-none pe-1"
                                }, _hoisted_35, 8, _hoisted_33)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_building_interior_type_modal, {
                "btn-text": 'Add Building Interior Type',
                "btn-class": "btn btn-primary",
                onOnUpdate: _ctx.buildingXTypesReset
              }, null, 8, ["onOnUpdate"]),
              (_ctx.buildingInteriorTypes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("table", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildingInteriorTypes, (buildingInteriorType) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: buildingInteriorType.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(buildingInteriorType.id), 1),
                            _createElementVNode("td", null, _toDisplayString(buildingInteriorType.name), 1),
                            _createElementVNode("td", null, [
                              (buildingInteriorType.image)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    target: "_blank",
                                    href: buildingInteriorType.imageSigned,
                                    download: ""
                                  }, _hoisted_42, 8, _hoisted_40))
                                : (_openBlock(), _createElementBlock("span", _hoisted_43, _hoisted_45))
                            ]),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildingInteriorType.anchorPoints, (point, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: index,
                                  class: "border border-2 me-1 px-1"
                                }, _toDisplayString(point), 1))
                              }), 128))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_46, [
                                _createVNode(_component_building_interior_type_modal, {
                                  "btn-text": '',
                                  "modal-title": 'Edit Building Interior Type [' + buildingInteriorType.name + ' (' + buildingInteriorType.id + ')]',
                                  "btn-icon": 'bi bi-pencil',
                                  "building-interior-type": buildingInteriorType,
                                  onOnUpdate: _ctx.buildingXTypesReset
                                }, null, 8, ["modal-title", "building-interior-type", "onOnUpdate"]),
                                _createElementVNode("a", {
                                  href: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.onDeleteBuildingInteriorType(buildingInteriorType)), ["prevent"]),
                                  class: "text-decoration-none pe-1"
                                }, _hoisted_49, 8, _hoisted_47)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_floor_type_modal, {
                "btn-text": 'Add Floor Type',
                "btn-class": "btn btn-primary",
                onOnUpdate: _ctx.buildingXTypesReset
              }, null, 8, ["onOnUpdate"]),
              (_ctx.floorTypes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("table", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.floorTypes, (floorType) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: floorType.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(floorType.id), 1),
                            _createElementVNode("td", null, _toDisplayString(floorType.name), 1),
                            _createElementVNode("td", null, [
                              (floorType.image)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    target: "_blank",
                                    href: floorType.imageSigned,
                                    download: ""
                                  }, _hoisted_56, 8, _hoisted_54))
                                : (_openBlock(), _createElementBlock("span", _hoisted_57, _hoisted_59))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_60, [
                                _createVNode(_component_floor_type_modal, {
                                  "btn-text": '',
                                  "modal-title": 'Edit Floor Type [' + floorType.name + ' (' + floorType.id + ')]',
                                  "btn-icon": 'bi bi-pencil',
                                  "floor-type": floorType,
                                  onOnUpdate: _ctx.buildingXTypesReset
                                }, null, 8, ["modal-title", "floor-type", "onOnUpdate"]),
                                _createElementVNode("a", {
                                  href: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.onDeleteFloorType(floorType)), ["prevent"]),
                                  class: "text-decoration-none pe-1"
                                }, _hoisted_63, 8, _hoisted_61)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}